import React from 'react';

import { Icon } from '../Icon';
import { useModal } from '../../hooks/modal';
import { colors } from '../../styles/tokens';
import noAvatar from '../../assets/no-avatar.svg';

import {
  Avatar,
  Badge,
  CloseButton,
  Header,
  HeaderActions,
  HeaderInfo,
} from './styles';

interface ModalHeaderProps {
  title: string;
  subtitle?: string;
  avatarUrl?: string;
  badge?: string;
  onClose?: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  subtitle,
  avatarUrl,
  badge,
  onClose,
}) => {
  const { removeModal } = useModal();

  return (
    <Header>
      <HeaderInfo>
        {!!avatarUrl && <Avatar src={avatarUrl || noAvatar} alt={title} />}
        <div>
          <h3>{title}</h3>
          {!!subtitle && <p>{subtitle}</p>}
        </div>
      </HeaderInfo>

      <HeaderActions>
        {!!badge && <Badge>{badge}</Badge>}
        <CloseButton
          type="button"
          onClick={() => (onClose ? onClose() : removeModal())}
        >
          <Icon name="close" size={20} color={colors.onSurfaceVariant} />
        </CloseButton>
      </HeaderActions>
    </Header>
  );
};

export { ModalHeader };
